// One stable anonymous identity for the whole guest session, shared by BOTH
// the cart (as its guest_token) and the voice avatar (as its
// guest_identifier). Unifying them is what lets the agent — which resolves
// the buyer from the voice session server-side — write to the exact same
// cart the buyer's browser reads. Persisted so a guest keeps one basket and
// one set of cost guardrails across reloads.
const KEY = 'tempest.guestId'

export function getGuestId(): string {
  let id = localStorage.getItem(KEY)
  if (!id) {
    id = `guest-${crypto.randomUUID()}`
    localStorage.setItem(KEY, id)
  }
  return id
}
